import { Card } from '../components/ui/card';
import { LoadingSpinner } from '../components/ui/loading-states';
import { QueryError } from '../components/ui/error-state';
import { useEmployees, useDepartments, useLocations, useAttendanceEvents } from '../hooks/useApi';
import { useAuth } from '../providers/AuthProvider';
import { MetricCard } from '../components/dashboard/MetricCard';
import { RecentCheckInsTable } from '../components/dashboard/RecentCheckInsTable';
import { Users, Building2, MapPin, TrendingUp } from 'lucide-react';

export function Dashboard() {
  const { isAuthenticated } = useAuth();
  const employeesQuery = useEmployees({ limit: 1 }, { enabled: isAuthenticated }); // Just for count
  const departmentsQuery = useDepartments({ limit: 1 }, { enabled: isAuthenticated }); // Just for count
  const locationsQuery = useLocations({ limit: 1 }, { enabled: isAuthenticated }); // Just for count
  
  // Получаем последние 5 событий прихода
  const recentCheckInsQuery = useAttendanceEvents({ 
    limit: 5, 
    sort: 'DESC',
    eventType: 'check_in'
  });
  
  return (
    <div className="space-y-8 flex-1 overflow-auto">
      <div>
        <h1 className="text-h1 gradient-text-blue">Панель управления</h1>
        <p className="text-muted-foreground mt-2 text-body-lg">
          Добро пожаловать в TCO Панель администратора v2.0
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {/* Total Employees Card */}
        <MetricCard
          title="Всего сотрудников"
          value={employeesQuery.data?.total || 0}
          icon={Users}
          trend={{ value: 12, isPositive: true }}
          iconColor="text-tco-blue"
          iconBgColor="bg-tco-blue-100"
        />

        {/* Active Today Card */}
        <MetricCard
          title="Активны сегодня"
          value={employeesQuery.data?.total 
            ? Math.floor(employeesQuery.data.total * 0.85) 
            : 0
          }
          icon={TrendingUp}
          trend={{ value: 8, isPositive: true }}
          iconColor="text-success"
          iconBgColor="bg-success-light"
        />

        {/* Locations Card */}
        <MetricCard
          title="Локации"
          value={locationsQuery.data?.total || 0}
          icon={MapPin}
          trend={{ value: 5, isPositive: true }}
          iconColor="text-info"
          iconBgColor="bg-info-light"
        />

        {/* Departments Card */}
        <MetricCard
          title="Отделы"
          value={departmentsQuery.data?.total || 0}
          icon={Building2}
          iconColor="text-warning"
          iconBgColor="bg-warning-light"
        />
      </div>

      {/* Recent Check-ins */}
      <Card className="p-6">
        <h3 className="text-h3 mb-6">Последние отметки</h3>
        {recentCheckInsQuery.isLoading ? (
          <div className="flex justify-center py-8">
            <LoadingSpinner />
          </div>
        ) : recentCheckInsQuery.isError ? (
          <QueryError
            error={recentCheckInsQuery.error}
            refetch={recentCheckInsQuery.refetch}
            className="p-4"
          />
        ) : (
          <RecentCheckInsTable 
            events={recentCheckInsQuery.data?.data || []}
          />
        )}
      </Card>
    </div>
  );
}